<template>
    <div class="pdf-content">
      <!-- <pdf class="pdf-content" v-for="i in numPages" :key="i" :page="i" :src="pdfSrc" /> -->
       <!-- <object :data="pdfSrc" type="application/pdf" width="100%" height="100%"></object> -->
       <iframe class="pdf-content" :src="pdfSrc" frameborder="0"></iframe>
    </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    name: "ViewPdf",
    props: {},
    data() {
      return {
        pdfWorker: null,
        pdfSrc: '',
        numPages: 0,
      }
    },
    created() {
      this.pdfSrc = encodeURI(decodeURIComponent(this.$route.query.url && this.$route.query.url.replace(/%(?![0-9A-Fa-f]{2})/g, '%25')));
      console.log('+++++++++++++++++ this.pdfSrc +++++++++++++++++', this.pdfSrc);
      const fileName = this.getFileName(this.pdfSrc);
      console.log('+++++++++++++++++ fileName +++++++++++++++++', fileName);
      fileName && (document.title = fileName);
      try {
          this.pdfWorker = pdf.createLoadingTask(this.pdfSrc)
          pdf.createLoadingTask(this.pdfSrc)
          console.log(this.pdfWorker,'11111111',this.pdfSrc)
          this.pdfWorker.promise.then(pdf => {
              console.log(pdf)
              this.numPages = pdf.numPages;
          })
          .catch(err=>console.info(err));
      } catch (error) {
          console.info(error);
      }
    },
    components: {
        pdf,
    },
    methods: {
        destroyWorker() {
            this.pdfWorker._worker && this.pdfWorker._worker.destroy();
        },
    }
  }
</script>

<style lang="scss" scoped>
.pdf-content{
    width: 100%;
    height: 100%;

    canvas {
      width: 100% !important;
    }

    ::v-deep canvas {
      width: 100% !important;
    }

    ::v-deep {
      canvas {
        width: 100% !important;
      }
    }
}
</style>